///
/// EarthBrowser
///
/// Dataset Scene Redux Slice
///
/// Stores reference to the singleton dataset-distribution layer manager for global access
///
/// Created by Matt Giger on 1/2/2026
/// Copyright (c) 2026 Geodata Labs
///

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { DatasetLayerManager } from '@/earthbrowser/dataset-distribution/DatasetLayerManager'

interface DatasetSceneState {
	layerManager: DatasetLayerManager | null
}

const initialState: DatasetSceneState = {
	layerManager: null
}

const datasetSceneSlice = createSlice({
	name: 'datasetScene',
	initialState,
	reducers: {
		setLayerManager: (state, action: PayloadAction<DatasetLayerManager>) => {
			state.layerManager = action.payload
		},
		clearLayerManager: (state) => {
			state.layerManager = null
		}
	}
})

export const { setLayerManager, clearLayerManager } = datasetSceneSlice.actions
export default datasetSceneSlice.reducer


